module.exports = __webpack_public_path__ + "img/DateTimeRange.77bbfdeb.svg";